/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  CreateRideRequest,
  GetRideNearbyVehiclesV1Params,
  GetRideTariffsV1Params,
  RideDto,
  RideLocationsDto,
  RideTariffDto,
  RideVehicleDto,
  UpdateRideLocationRequest
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type createRideV1Response201 = {
  data: RideDto
  status: 201
}

export type createRideV1Response400 = {
  data: void
  status: 400
}

export type createRideV1Response401 = {
  data: void
  status: 401
}

export type createRideV1Response409 = {
  data: void
  status: 409
}

export type createRideV1Response422 = {
  data: void
  status: 422
}

export type createRideV1Response503 = {
  data: void
  status: 503
}

export type createRideV1ResponseSuccess = (createRideV1Response201) & {
  headers: Headers;
};
export type createRideV1ResponseError = (createRideV1Response400 | createRideV1Response401 | createRideV1Response409 | createRideV1Response422 | createRideV1Response503) & {
  headers: Headers;
};

export type createRideV1Response = (createRideV1ResponseSuccess | createRideV1ResponseError)

export const getCreateRideV1Url = () => {




  return `/api/v1/reservations/OndeOperator`
}

/**
 * Books a ride. A FREE ride is sent to Onde immediately and starts searching, exactly
 * as before. A PAID one is NOT: it is recorded with status AWAITING_PAYMENT and no car
 * is asked for until the fare has been held or taken, so nobody is ever driven on a
 * fare that was never secured. Subscribe to /hubs/rides either way.
 *
 * Notes:
 * - Pass pickupTime (RFC3339) to schedule a pre-booked ride instead of ASAP; an
 *   unparseable value returns 400 invalid_pickup_time.
 * - A PAID scheduled ride must be far enough out to survive the checkout: Onde refuses
 *   a pre-booking inside its own minimum delay (15 minutes today) and that is only
 *   checked when the ride is dispatched, which is after payment. Too close returns
 *   400 ride_pickup_too_soon. Free rides are exempt — they dispatch on the spot.
 * - Booking again while an earlier ride of the same customer is still AWAITING_PAYMENT
 *   supersedes it: the older one is cancelled as CANCELLED_SUPERSEDED and any payment
 *   started against it is released.
 * - vehicleType and tariffId are advisory only. The server resolves the tariff from the
 *   route, because Onde keeps one per area and they differ in price AND in vehicle.
 * - Only one ride may be under way at a time: returns 409 ride_already_in_progress when
 *   the customer already has one in SEARCH/ASSIGNED/STARTED/ARRIVED/TRANSFERRING. A
 *   pre-booking waiting for its pickup time does NOT block a new ride, so a customer
 *   with a booking for tomorrow can still hail a car now.
 * - Payment method is not a request field — it is always THIRD_PARTY (the only method
 *   our Onde operator token may create orders with).
 * - Whether the ride must be paid for is decided here, from the service category and
 *   the Onde fare, and reported as requiresPayment on the response. Obey that flag
 *   rather than inferring from estimatedCost, which cannot tell "free" apart from
 *   "no price could be established".
 * - A paid category whose fare cannot be established returns 422
 *   ride_price_unavailable and no order is created with Onde — the ride is refused
 *   rather than given away.
 * - An unrecognised serviceCategoryNodeKey returns 400
 *   ride_service_category_unknown; it is never assumed to be a free category.
 * @summary Call a car
 */
export const createRideV1 = async (createRideRequest: CreateRideRequest, options?: Parameters<typeof customFetch>[1]): Promise<createRideV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createRideV1Response>(getCreateRideV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createRideRequest)
  }
);}


export type listRidesV1Response200 = {
  data: RideDto[]
  status: 200
}

export type listRidesV1Response401 = {
  data: void
  status: 401
}

export type listRidesV1ResponseSuccess = (listRidesV1Response200) & {
  headers: Headers;
};
export type listRidesV1ResponseError = (listRidesV1Response401) & {
  headers: Headers;
};

export type listRidesV1Response = (listRidesV1ResponseSuccess | listRidesV1ResponseError)

export const getListRidesV1Url = () => {




  return `/api/v1/reservations/OndeOperator`
}

/**
 * Returns the calling user's rides, most recent first.
 * @summary Ride history
 */
export const listRidesV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<listRidesV1Response> => {

  return customFetch<listRidesV1Response>(getListRidesV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type getRideV1Response200 = {
  data: RideDto
  status: 200
}

export type getRideV1Response401 = {
  data: void
  status: 401
}

export type getRideV1Response404 = {
  data: void
  status: 404
}

export type getRideV1ResponseSuccess = (getRideV1Response200) & {
  headers: Headers;
};
export type getRideV1ResponseError = (getRideV1Response401 | getRideV1Response404) & {
  headers: Headers;
};

export type getRideV1Response = (getRideV1ResponseSuccess | getRideV1ResponseError)

export const getGetRideV1Url = (publicGuid: string,) => {




  return `/api/v1/reservations/OndeOperator/${publicGuid}`
}

/**
 * Returns the current state of a ride, refreshing it from Onde first if not yet in a terminal state. Prefer /hubs/rides for live tracking; use this for the initial load.
 * @summary Get ride state
 */
export const getRideV1 = async (publicGuid: string, options?: Parameters<typeof customFetch>[1]): Promise<getRideV1Response> => {

  return customFetch<getRideV1Response>(getGetRideV1Url(publicGuid),
  {
    ...options,
    method: 'GET'


  }
);}


export type cancelRideV1Response204 = {
  data: void
  status: 204
}

export type cancelRideV1Response401 = {
  data: void
  status: 401
}

export type cancelRideV1Response404 = {
  data: void
  status: 404
}

export type cancelRideV1Response409 = {
  data: void
  status: 409
}

export type cancelRideV1Response503 = {
  data: void
  status: 503
}

export type cancelRideV1ResponseSuccess = (cancelRideV1Response204) & {
  headers: Headers;
};
export type cancelRideV1ResponseError = (cancelRideV1Response401 | cancelRideV1Response404 | cancelRideV1Response409 | cancelRideV1Response503) & {
  headers: Headers;
};

export type cancelRideV1Response = (cancelRideV1ResponseSuccess | cancelRideV1ResponseError)

export const getCancelRideV1Url = (publicGuid: string,) => {




  return `/api/v1/reservations/OndeOperator/${publicGuid}/cancel`
}

/**
 * Cancels a ride via Onde (CANCELLED_BY_DISPATCH).
 *
 * Returns 409 invalid_status_for_cancel when the ride is already in a terminal state,
 * and 409 ride_cancellation_window_closed once the driver has arrived on a ride whose
 * fare is held or charged — that is when the money is taken, so it is also when
 * cancelling stops being free. A ride that costs nothing stays cancellable throughout.
 *
 * Cancelling in time releases the money automatically: the authorisation is cancelled
 * when the fare was only held, or refunded when it had already been charged.
 * @summary Cancel a ride
 */
export const cancelRideV1 = async (publicGuid: string, options?: Parameters<typeof customFetch>[1]): Promise<cancelRideV1Response> => {

  return customFetch<cancelRideV1Response>(getCancelRideV1Url(publicGuid),
  {
    ...options,
    method: 'POST'


  }
);}


export type updateRideLocationV1Response204 = {
  data: void
  status: 204
}

export type updateRideLocationV1Response401 = {
  data: void
  status: 401
}

export type updateRideLocationV1Response404 = {
  data: void
  status: 404
}

export type updateRideLocationV1Response409 = {
  data: void
  status: 409
}

export type updateRideLocationV1Response503 = {
  data: void
  status: 503
}

export type updateRideLocationV1ResponseSuccess = (updateRideLocationV1Response204) & {
  headers: Headers;
};
export type updateRideLocationV1ResponseError = (updateRideLocationV1Response401 | updateRideLocationV1Response404 | updateRideLocationV1Response409 | updateRideLocationV1Response503) & {
  headers: Headers;
};

export type updateRideLocationV1Response = (updateRideLocationV1ResponseSuccess | updateRideLocationV1ResponseError)

export const getUpdateRideLocationV1Url = (publicGuid: string,) => {




  return `/api/v1/reservations/OndeOperator/${publicGuid}/location`
}

/**
 * Forwards the passenger's current location to Onde so the driver can find them. Returns 409 if the ride is no longer active.
 * @summary Update passenger location
 */
export const updateRideLocationV1 = async (publicGuid: string,
    updateRideLocationRequest: UpdateRideLocationRequest, options?: Parameters<typeof customFetch>[1]): Promise<updateRideLocationV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateRideLocationV1Response>(getUpdateRideLocationV1Url(publicGuid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateRideLocationRequest)
  }
);}


export type getRideLocationsV1Response200 = {
  data: RideLocationsDto
  status: 200
}

export type getRideLocationsV1Response401 = {
  data: void
  status: 401
}

export type getRideLocationsV1Response404 = {
  data: void
  status: 404
}

export type getRideLocationsV1ResponseSuccess = (getRideLocationsV1Response200) & {
  headers: Headers;
};
export type getRideLocationsV1ResponseError = (getRideLocationsV1Response401 | getRideLocationsV1Response404) & {
  headers: Headers;
};

export type getRideLocationsV1Response = (getRideLocationsV1ResponseSuccess | getRideLocationsV1ResponseError)

export const getGetRideLocationsV1Url = () => {




  return `/api/v1/reservations/OndeOperator/locations`
}

/**
 * Everything the "Where from" / "Where to" sheet needs, in one call: the customer's saved
 * addresses, the JNcQUOI venue catalogue, Fashion Clinic stores and recently used places
 * from their own ride history. Every entry shares the same shape (name + city + address +
 * coordinates + source).
 *
 * Notes:
 * - Address-book entries may have lat/lng = null when the address was never geocoded
 *   (anything saved before coordinates were supported, or that the app chose not to
 *   geocode). The client must geocode those on selection before booking a ride with them.
 * - venues and stores both come from the CMS venue catalogue and are split on the
 *   isFashionClinicStore flag; both are only returned when they carry valid GPS
 *   coordinates in the CMS.
 * - venues the editor marked with hideInRangeRover in the CMS are left out of venues
 *   and stores entirely. The flag is per venue node, and venues sharing an address
 *   (same building) are separate nodes, so an address only disappears once every node
 *   on it is flagged. It does not affect recentTrips, which come from the customer's
 *   own ride history rather than the catalogue.
 * - recentTrips is de-duplicated by coordinate and capped (most recent first).
 * - city is culture-dependent (the venue's location node is culture-variant), so send
 *   Accept-Language here and send the SAME value on POST /me/rides. Echo the city back
 *   VERBATIM in pickupCity/dropoffCity: the same-city fare waiver compares those two
 *   strings with Ordinal equality and does not trim, so any reformatting, re-casing or
 *   re-geocoding of one end silently turns a free ride into a paid one.
 * @summary Places for the where-from / where-to picker
 */
export const getRideLocationsV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getRideLocationsV1Response> => {

  return customFetch<getRideLocationsV1Response>(getGetRideLocationsV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type getRideTariffsV1Response200 = {
  data: RideTariffDto[]
  status: 200
}

export type getRideTariffsV1Response400 = {
  data: void
  status: 400
}

export type getRideTariffsV1Response401 = {
  data: void
  status: 401
}

export type getRideTariffsV1Response503 = {
  data: void
  status: 503
}

export type getRideTariffsV1ResponseSuccess = (getRideTariffsV1Response200) & {
  headers: Headers;
};
export type getRideTariffsV1ResponseError = (getRideTariffsV1Response400 | getRideTariffsV1Response401 | getRideTariffsV1Response503) & {
  headers: Headers;
};

export type getRideTariffsV1Response = (getRideTariffsV1ResponseSuccess | getRideTariffsV1ResponseError)

export const getGetRideTariffsV1Url = (params?: GetRideTariffsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/reservations/OndeOperator/tariffs?${stringifiedParams}` : `/api/v1/reservations/OndeOperator/tariffs`
}

/**
 * Returns estimated fare options (one per available vehicle/tariff type) for a pickup and/or dropoff point. At least one of origin/destination is required. Pass pickupTime (RFC3339) to check fares for a scheduled pickup instead of ASAP — only tariffs with preBooking=true will be returned for a future pickupTime.
 * @summary Estimate ride fares
 */
export const getRideTariffsV1 = async (params?: GetRideTariffsV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getRideTariffsV1Response> => {

  return customFetch<getRideTariffsV1Response>(getGetRideTariffsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getRideNearbyVehiclesV1Response200 = {
  data: RideVehicleDto[]
  status: 200
}

export type getRideNearbyVehiclesV1Response401 = {
  data: void
  status: 401
}

export type getRideNearbyVehiclesV1Response503 = {
  data: void
  status: 503
}

export type getRideNearbyVehiclesV1ResponseSuccess = (getRideNearbyVehiclesV1Response200) & {
  headers: Headers;
};
export type getRideNearbyVehiclesV1ResponseError = (getRideNearbyVehiclesV1Response401 | getRideNearbyVehiclesV1Response503) & {
  headers: Headers;
};

export type getRideNearbyVehiclesV1Response = (getRideNearbyVehiclesV1ResponseSuccess | getRideNearbyVehiclesV1ResponseError)

export const getGetRideNearbyVehiclesV1Url = (params: GetRideNearbyVehiclesV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/reservations/OndeOperator/vehicles?${stringifiedParams}` : `/api/v1/reservations/OndeOperator/vehicles`
}

/**
 * Returns active vehicles currently near the given origin point.
 * @summary Nearby active vehicles
 */
export const getRideNearbyVehiclesV1 = async (params: GetRideNearbyVehiclesV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getRideNearbyVehiclesV1Response> => {

  return customFetch<getRideNearbyVehiclesV1Response>(getGetRideNearbyVehiclesV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


